const rates = {
  createRateBtn: 'Erstellen',
  showBreakdownBtn: 'Breakdown anzeigen',
  total: 'Total: ',

  table: {
    headers: {
      isAvailable: 'Verfügbar',
      isActive: 'Status',
    },
    cells: {
      isActive: {
        true: 'Aktiv',
        false: 'Inaktiv',
      },
      isAvailable: {
        true: 'JA',
        false: 'NEIN',
      },
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
  },

  deleteModal: {
    header: 'Tarife löschen',
    body: 'Sie sind dabei, {{num}} Tarife zu löschen.',
  },

  rateTypeOptions: {
    Base: 'Basis',
    Addition: 'Zusatz',
    Percent: 'Prozent',
    Total: 'Gesamt',
  },

  additions: {
    value: 'Wert',
    valueType: 'Werttyp',
    name: 'Name',
    hour1: 'Startzeit',
    hour2: 'Endzeit',
    date1: 'Startdatum',
    date2: 'Enddatum',
    cancel: 'Stornieren',
    addAddition: 'Zusatz hinzufügen',
    priority: 'Priorität',
    weekDays: 'Wochentage',
    newAddition: 'Neuer Zusatz',
    price: 'Preis',
    total: 'Gesamt',
    percent: 'Prozent',
    columnExist: 'Titel existiert bereits',
  },

  toast: {
    error: {
      badResponse: '[Standort] fehlerhafte Serverantwort',
    },
  },

  create: {
    successToast: {
      message: 'Erfolg! Tarif erstellt',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Tarif konnte nicht erstellt werden.',
    },
  },

  edit: {
    successToast: {
      message: 'Erfolg! Tarif aktualisiert',
    },

    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Tarif konnte nicht aktualisiert werden.',
    },

    modalError: {
      header: 'Fehler.',
      body: 'Tarif kann nicht aktualisiert werden.',
    },
  },

  delete: {
    successToast: {
      message: '[Raten] erfolgreich gelöscht',
    },

    errorToast: {
      message: '[Raten] schlechte Serverantwort',
    },
  },

  forms: {
    update: {
      tabs: {
        generalInfo: 'Allgemeine Informationen',
        generalAdditions: 'Allgemeine Ergänzungen',
        attributeAdditions: 'Attributergänzungen',
        geoAdditions: 'Geo-Ergänzungen',
        history: 'Geschichte',
      },
    },

    header: {
      createRate: {
        title: 'Erstellen',
      },

      updateRate: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    isActive: {
      fields: {
        isActive: {
          on: 'Aktiv',
          off: 'Inaktiv',
        },
      },
    },

    information: {
      details: {
        header: 'Tarifdetails',
        fields: {
          units: {
            name: 'Bereiche',
          },
          from: {
            name: 'Von',
          },
          to: {
            name: 'Bis',
          },
          supplierId: {
            name: 'Anbieter',
          },
          servicesIds: {
            name: 'Dienst',
          },
          profilesIds: {
            name: 'Profil',
          },
          biDirectional: {
            name: 'Bidirektional',
          },
          group: {
            name: 'Tarifgruppe',
          },
          name: {
            name: 'Name',
          },
          code: {
            name: 'Code',
          },
        },
      },
    },

    type: {
      header: 'Tarifart',
      fields: {
        fromAreasIds: 'Von Zone',
        toAreasIds: 'Zur Zone',
        biDirectional: 'Bidirektional',
        basePrice: 'Grundpreis',
        durationFactors: {
          baseDuration: 'Basisdauer',
          pricePerAdditional: {
            value: 'Pro zusätzlicher Minute',
            type: {
              fixed: 'Behoben',
              percentage: 'Prozentsatz (von der Basis)',
            },
          },
        },
        distanceFactors: {
          baseDistance: 'Basisdistanz',
          pricePerAdditional: {
            value: 'Pro zusätzlichem Kilometer',
            type: {
              fixed: 'Behoben',
              percentage: 'Prozentsatz (von der Basis)',
            },
          },
        },
      },
      addBtn: 'Hinzufügen',
    },

    availability: {
      header: 'Tarifverfügbarkeit',
      fields: {
        from: 'Verfügbar ab',
        to: 'Verfügbar bis',
        fromTime: 'Zeit von',
        toTime: 'Zeit bis',
        weekDays: 'Wochentage',
      },
      addBtn: 'Verfügbarkeit hinzufügen',
    },

    addition: {
      header: 'Allgemeine Ergänzungen',
      fields: {
        stops: {
          included: 'Enthaltene Stopps',
          pricePerAddition: {
            value: 'Pro zusätzlichem Stopp',
            type: {
              fixed: 'Behoben',
              percentage: 'Prozentsatz (von der Basis)',
            },
          },
        },
        seats: {
          included: 'Inbegriffene Sitzplätze',
          pricePerAddition: {
            value: 'Pro zusätzlichem Sitzplatz',
            type: {
              fixed: 'Behoben',
              percentage: 'Prozentsatz (von der Basis)',
            },
          },
        },
      },
    },

    peakHoursSurcharge: {
      header: 'Spitzenstundenzuschlag',
      fields: {
        name: 'Name',
        fromTime: 'Von',
        toTime: 'Bis',
        priceAddition: {
          value: 'Preisaufschlag',
          type: {
            fixed: 'Behoben',
            percentage: 'Prozentsatz (von der Basis)',
          },
        },
        weekDays: 'Wochentage',
      },
      addBtn: 'Zuschlag für Spitzenzeiten hinzufügen',
    },

    attributeAdditions: {
      header: 'Details zum Hinzufügen von Attributen',
      fields: {
        attributeIds: 'Attribut(e)',
        included: 'Enthaltene Menge',
        perAdditional: {
          value: 'Pro zusätzlichem Attribut',
          type: {
            fixed: 'Behoben',
            percentage: 'Prozentsatz',
          },
        },
      },
      addBtn: 'Attribute hinzufügen',
    },

    geoAdditions: {
      generalAreaEntrance: {
        header: 'Allgemeiner Zoneneingang',
        fields: {
          pricePerArea: 'Preis pro Zone',
          chargingMethod: {
            name: 'Lademethode',
            options: {
              drivingThrough: 'Durchfahrt',
              stops: 'Haltestellen',
            },
          },
          type: {
            fixed: 'Behoben',
            percentage: 'Prozentsatz',
          },
        },
      },
      specificAreaEntrance: {
        header: 'Eingang zu einer bestimmten Zone',
        fields: {
          areasIds: 'Zonen',
          pricePerArea: 'Preis pro Zone',
          chargingMethod: {
            name: 'Lademethode',
            options: {
              drivingThrough: 'Durchfahrt',
              stops: 'Haltestellen',
            },
          },
          type: {
            fixed: 'Behoben',
            percentage: 'Prozentsatz',
          },
        },
        addBtn: 'Zone hinzufügen',
      },
    },
  },
};

export default rates;
